import { createSelector } from 'reselect'
import { fileEntitySelector } from 'containers/Project/FileSection/selectors'
import * as R from 'ramda'

const nameSelector = state => state.project.fileRename.name
const activeSelector = state => state.project.fileRename.active
const idSelector = state => state.project.fileRename.id
const fileSelector = createSelector(
  idSelector,
  fileEntitySelector,
  R.prop
)

export {
  activeSelector,
  idSelector,
  fileSelector,
  nameSelector,
}
